/*
 * Curly Cart: hide stale cart contents and count badges immediately on return.
 */
(function () {
  'use strict';
  var markerKey = 'curly_bundle_checkout_cleanup';
  if (window.__curlyBundleReturnCleanupInstalled) return;
  window.__curlyBundleReturnCleanupInstalled = true;
  var cleanupRunning = false;

  function hasMarker() {
    try { return sessionStorage.getItem(markerKey) === '1'; }
    catch (e) { return false; }
  }

  var selectors = [
    '#cart-icon-bubble .cart-count-bubble',
    '#cart-icon-bubble .cart-count',
    '#cart-icon-bubble [class*="count"]',
    '#cart-icon-bubble [class*="bubble"]',
    '#cart-icon-bubble [data-count]',
    '#cart-icon-bubble [data-cart-count]',
    '#cart-icon-bubble [data-cart-item-count]',
    'a[href="/cart"] .cart-count-bubble',
    'a[href="/cart"] .cart-count',
    'a[href="/cart"] [class*="count"]',
    'a[href="/cart"] [class*="bubble"]',
    'a[href="/cart"] [data-count]',
    'a[href$="/cart"] .cart-count-bubble',
    'a[href$="/cart"] .cart-count',
    'a[href$="/cart"] [class*="count"]',
    'a[href$="/cart"] [class*="bubble"]',
    '.header__icon--cart .cart-count-bubble',
    '.header__icon--cart [class*="count"]',
    '.header__icon--cart [class*="bubble"]',
    '.cart-link__bubble',
    '.site-header-cart--count',
    '#CartCount',
    '#cartCount'
  ];

  function hideCartBadges() {
    if (!hasMarker()) return;
    document.documentElement.classList.add('curly-bundle-cart-clearing');
    try {
      document.querySelectorAll(selectors.join(',')).forEach(function (el) {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.setAttribute('aria-hidden', 'true');
      });
    } catch (e) {}
  }

  function removeMarker() {
    try { sessionStorage.removeItem(markerKey); } catch (e) {}
  }

  async function clearBundleCartOnReturn() {
    if (!hasMarker() || cleanupRunning) return;
    hideCartBadges();
    cleanupRunning = true;
    try {
      var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
      var response = await fetch(root + 'cart/clear.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' },
        cache: 'no-store'
      });
      if (!response.ok) throw new Error('Cart clear failed: HTTP ' + response.status);
      removeMarker();
      // After a bundle checkout, always return the customer to the wishlist.
      window.location.replace(root + 'pages/whishlist');
    } catch (e) {
      console.error('[Curly Cart] Cart cleanup failed:', e);
      cleanupRunning = false;
    }
  }

  hideCartBadges();
  clearBundleCartOnReturn();
  window.addEventListener('pageshow', function () {
    hideCartBadges();
    clearBundleCartOnReturn();
  });

  if (window.MutationObserver) {
    new MutationObserver(hideCartBadges).observe(document.documentElement, {
      childList: true, subtree: true
    });
  }
})();
